import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import CommonCounter from '../counter/CommonCounter'

const DEFAULT_TITLE_LINES = ['비즈니스에 최적화된', '엔터프라이즈', '소프트웨어 개발']

/**
 * 원래 레이아웃(이중 히어로·화살표·카운터 박스) 유지, 이미지·카피는 선택적으로 교체합니다.
 *
 * @param {{
 *   heroImage1?: string;
 *   heroImage2?: string;
 *   heroImage1Alt?: string;
 *   heroImage2Alt?: string;
 *   subTitle?: string;
 *   titleLines?: string[];
 * }} [props]
 */
const ThemeBannerTwo = (props = {}) => {
    const {
        heroImage1,
        heroImage2,
        heroImage1Alt,
        heroImage2Alt,
        subTitle,
        titleLines,
    } = props
    const lines = titleLines?.length ? titleLines : DEFAULT_TITLE_LINES
    const img1Src = heroImage1 ?? '/assets/img/hero/hero-1b.jpg'
    const img2Src = heroImage2 ?? '/assets/img/hero/hero-2b.jpg'
    const customCircle = Boolean(heroImage2)

    return (
        <Fragment>
            <div
                className={`theme-banner-two pt-220 pb-230 pt-lg-120 pt-md-80 pt-xs-60 pb-sm-120${
                    customCircle ? ' theme-banner-two--custom-circle' : ''
                }`}
            >
                <img className="banner-shape shape-one" src="/assets/img/shape/star-3b.svg" alt="배경 도형"/>
                <img className="banner-shape shape-two" src="/assets/img/shape/star-4b.svg" alt="배경 도형"/>
                <img className="banner-shape shape-three d-none d-lg-inline-block" src="/assets/img/shape/star-2.svg" alt="배경 도형"/>
                <div className="container">
                    <div className="row gx-4 gx-xxl-5 align-items-center">
                        <div className="col-xl-6 col-md-7">
                            <div className="theme__content__two text-md-start text-center">
                                <h4 className="hero-sub-title mb-25">
                                    {subTitle ?? '엔터프라이즈 소프트웨어 전문 기업'}
                                </h4>
                                <h1 className="main-title-two">
                                    {lines.map((line, i) => (
                                        <span key={i}>{line}</span>
                                    ))}
                                </h1>
                                <Link className="theme_btn" to="/contact">프로젝트 문의하기</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero-img-wrapper">
                    <img
                        className={`hero-img img-1${heroImage1 ? ' hero-img--custom' : ''}`}
                        src={img1Src}
                        alt={heroImage1Alt ?? '소프트웨어 개발 현장'}
                        loading="eager"
                        decoding="async"
                    />
                    <img
                        className={`hero-img img-2${heroImage2 ? ' hero-img--custom' : ''}`}
                        src={img2Src}
                        alt={heroImage2Alt ?? '개발팀 협업'}
                        loading="eager"
                        decoding="async"
                    />
                    <img className="hero-img arrow-1" src="/assets/img/shape/arrow-1b.svg" alt="" />
                    <img className="hero-img arrow-2" src="/assets/img/shape/arrow-2b.svg" alt="" />
                    <img className="hero-img arrow-3" src="/assets/img/shape/arrow-3b.svg" alt="" />
                    {!customCircle && (
                        <>
                            <div className="hero-box">
                                <span className="icon">
                                    <img src="/assets/img/icon/icon-13b.svg" alt="수상 아이콘" />
                                </span>
                                <div className="box">
                                    <span className="text-theme">
                                        <span className="counter"><CommonCounter value="150" /></span>+
                                    </span>
                                    완료 프로젝트
                                </div>
                            </div>
                            <div className="hero-box-two">
                                <div className="icon">
                                    <img src="/assets/img/icon/icon-14b.svg" alt="고객 아이콘" />
                                </div>
                                <div className="box">
                                    <span className="text-theme">
                                        <span className="counter"><CommonCounter value="98" /></span>%
                                    </span>
                                    재계약률
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default ThemeBannerTwo
